import { HOUR_IN_MS } from 'src/utils/date';

/** Formats the remaining reply window as a compact localized hour/minute count. */
export const formatSessionTimeRemaining = (
  milliseconds: number,
  locale: string
): string => {
  const hours = milliseconds >= HOUR_IN_MS;
  const value = Math.max(
    1,
    Math.ceil(milliseconds / (hours ? HOUR_IN_MS : 60_000))
  );
  return new Intl.NumberFormat(locale, {
    style: 'unit',
    unit: hours ? 'hour' : 'minute',
    unitDisplay: 'narrow',
  }).format(value);
};
